import { call, put, takeEvery, select } from "redux-saga/effects";
import { salaryLoader, setBonuses } from "./actions";
import {
  getSalaryBonuses,
  postSalaryBonuses,
  deleteSalaryBonuses,
  patchSalaryBonuses,
  getPositions,
} from "../../helpers/jwt_helper.js";
import {
  GET_SALARY_BONUSES,
  POST_SALARY_BONUS,
  PATCH_SALARY_BONUS,
  DELETE_SALARY_BONUS,
} from "./actionType";

import {
  showErrorMessage,
  getErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";

function* onGetSalaryBonuses({ payload: data }) {
  try {
    yield put(salaryLoader());
    let response = yield call(getSalaryBonuses, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      position__title: data.position__title,
    });
    let positions = yield call(getPositions, {
      size: 0,
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
          position:
            positions.find(pos => pos.id === i.position)?.title || i.position,
        })),
      };
    } else {
      response = {
        results: response,
      };
    }
    // response = {
    //   ...data,
    //   ...response,
    //   results: response.results.map(i => ({
    //     ...i,
    //     created_at: new Date(i.created_at).toDateString(),
    //     position:
    //       positions.find(pos => pos.id === i.position)?.title || i.position,
    //   })),
    // };
    yield put(setBonuses(response));
    yield put(salaryLoader());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(salaryLoader());
  }
}

function* onPostSalaryBonuses({ payload: data }) {
  try {
    let currentData = yield select(state => state.SalaryBonuses.data);
    yield put(salaryLoader());
    yield call(postSalaryBonuses, data);
    yield call(onGetSalaryBonuses, { payload: currentData });
    yield put(salaryLoader());
    showSuccessMessage("Add media buyer bonus has been successfully");
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(salaryLoader());
  }
}

function* onPatchSalaryBonuses({ payload: params }) {
  try {
    let currentData = yield select(state => state.SalaryBonuses.data);
    yield put(salaryLoader());
    yield call(patchSalaryBonuses, params.id, params.data);
    yield call(onGetSalaryBonuses, { payload: currentData });
    yield put(salaryLoader());
    showSuccessMessage("Update media buyer bonus has been successfully");
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(salaryLoader());
  }
}

function* onDeleteSalaryBonuses({ payload: id }) {
  try {
    let currentData = yield select(state => state.SalaryBonuses.data);
    yield put(salaryLoader());
    yield call(deleteSalaryBonuses, id);
    yield call(onGetSalaryBonuses, { payload: currentData });
    yield put(salaryLoader());
    showSuccessMessage("Delete media buyer bonus has been successfully");
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(salaryLoader());
  }
}

function* SalaryBonusesSaga() {
  yield takeEvery(GET_SALARY_BONUSES, onGetSalaryBonuses);
  yield takeEvery(POST_SALARY_BONUS, onPostSalaryBonuses);
  yield takeEvery(PATCH_SALARY_BONUS, onPatchSalaryBonuses);
  yield takeEvery(DELETE_SALARY_BONUS, onDeleteSalaryBonuses);
}

export default SalaryBonusesSaga;
